export default __webpack_public_path__ + "static/media/atk.2753b7cc.svg";